export { default } from './SetupAuthenticator';
